<template>
  <Authenticated>
    <div class="floor-plan-container">
      <div class="header">
        <div class="info">
          <h2 class="blue">{{ formatLayout }}</h2>
          <h2 class="blue" v-if="currentTable">{{ formatTable }}</h2>
          <h2 class="blue" v-else>Select a Table</h2>
          <h2 class="blue">{{ formatChair }}</h2>
        </div>
        <div v-if="currentLayout.totalTables > 0" class="info">
          <h2 class="blue">Total: {{ currentLayout.totalTables }}</h2>
          <h2 class="blue">Taken: {{ activeTabs }}</h2>
          <h2 v-if="currentLayout.totalTables - activeTabs == 1" class="blue">Free: {{ currentLayout.totalTables - activeTabs }}</h2>
          <h2 v-else class="blue">Free: {{ currentLayout.totalTables - activeTabs }}</h2>
        </div>
        <div v-else class="info">
          <h2 class="blue">No tables in selected Layout</h2>
        </div>
      </div>
      <section class="actions-bar">
        <div class="buttons-container">
          <div v-for="layout in floorplans" :key="layout">
            <button @click="handleLayout(layout[0])" class="layout-btn" :class="isActive ? 'selected' : ''">{{ layout[0].name.split("_").join(" ") }}</button>
          </div>
        </div>
        <div class="zoom-buttons">
          <button @click="zoomOut" class="layout-btn">Zoom Out</button>
          <button @click="zoomIn" class="layout-btn">Zoom In</button>
          <button @click="handleChairs" v-if="showCharis" class="layout-btn alt-text">Hide Chairs</button>
          <button @click="handleChairs" v-if="!showCharis" class="layout-btn alt-text">Show Chairs</button>
        </div>
      </section>
      <div class="svg-container" ref="svgContainer"></div>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FloorPlan",
  components: {
    Authenticated,
  },

  data() {
    return {
      scale: 1,
      activeTabs: 0,
      tables: [],
      showCharis: true,
      isActive: false,
      tableListeners: new Map(),
    };
  },

  async mounted() {
    await this.$store.dispatch("getSettings");
    await this.$store.dispatch("getHistory");
    await this.$store.dispatch("setLayouts");
    // this.handleCurrentLayout();
  },

  computed: {
    ...mapGetters({
      currentTable: "currentTable",
      currentChair: "currentChair",
      currentLayout: "currentLayout",
      allLayouts: "allLayouts",
      history: "history",
      floorplans: "floorplans",
    }),

    formatLayout() {
      return this.formatter(this.currentLayout.layout);
    },

    formatTable() {
      return this.formatter(this.currentTable.table);
    },

    formatChair() {
      return this.formatter(this.currentChair);
    },

    tableName() {
      let t = "";
      if (this.currentLayout && this.currentTable) {
        t = this.currentLayout.layout.split("_")[1] + "_" + this.currentTable.table.split("_")[1];
      }
      return t;
    },

    layoutHandle() {
      if (Object.keys(this.currentLayout).length === 0) {
        return;
      }
      let tableInLayout = this.currentLayout.layout.split("_")[1];
      return tableInLayout;
    },
  },

  beforeDestroy() {
    this.clearTableListeners();
  },

  methods: {
    ...mapActions(["setCurrentLayout", "setCurrentTable", "setCurrentChair", "initialiseCartFromHistory", "clearCart"]),

    handleChairs() {
      this.showCharis = !this.showCharis;
      let charis = this.$refs.svgContainer.querySelectorAll(".draggable");
      charis.forEach((chair) => {
        chair.children[0].style.display = this.showCharis ? "block" : "none";
      });
    },

    renderSVGToContainer(svgCode) {
      this.$refs.svgContainer.innerHTML = svgCode;
      return this.$refs.svgContainer;
    },

    applyPortraitStyling(isCurrentLayout = false) {
      if (window.matchMedia("(orientation: portrait)").matches) {
        this.$nextTick(() => {
          let svg = this.$refs.svgContainer.querySelector("svg");
          if (svg) {
            svg.style.transform = "scale(0.7)";
            svg.style.transformOrigin = "top left";
            if (isCurrentLayout) {
              svg.style.width = "550%";
              svg.style.height = "100%";
            }
            this.scale = 0.6;
          }
        });
      }
    },

    setupTableListeners(svgContainer) {
      this.clearTableListeners();
      const groups = svgContainer.querySelectorAll("g");

      groups.forEach((g) => {
        if (g.id.includes("table")) {
          const listener = this.createTableClickListener(g);
          g.addEventListener("click", listener);
          this.tableListeners.set(g, listener);
        }
      });
      this.initOpenTabs(groups);
    },

    createTableClickListener(table) {
      return () => {
        this.clearCart();
        let t = {
          table: table.id,
          svg: table.outerHTML,
        };
        this.setCurrentTable(t);

        let existingOrder = this.history.find((tab) => {
          const orderData = tab.value;
          if (!orderData || !orderData.name) return;
          let [first, second, third] = orderData.name.split("_");
          let layout = `layout_${first}`;
          if (layout == this.currentLayout.layout) {
            return orderData && `${second}_${third}` === table.id && orderData.payments.length === 0;
          }
        });
        if (existingOrder && existingOrder.value) {
          this.initialiseCartFromHistory(existingOrder.value);
          this.$router.push("/store");
        } else {
          this.$router.push("/store");
        }
      };
    },

    clearTableListeners() {
      this.tableListeners.forEach((listener, element) => {
        element.removeEventListener("click", listener);
      });
      this.tableListeners.clear();
    },

    handleLayout(layout) {
      this.setCurrentTable({});
      this.isActive = !this.isActive;
      this.activeTabs = 0;
      let svgContainer = this.renderSVGToContainer(layout.svg);

      let tablesAmount = this.$refs.svgContainer.querySelectorAll(".draggable").length;
      let l = {
        layout: layout.name,
        svg: layout.svg,
        totalTables: tablesAmount,
      };

      this.applyPortraitStyling(false);
      this.setCurrentLayout(l);
      this.setupTableListeners(svgContainer);
    },

    handleCurrentLayout() {
      let svgContainer = this.renderSVGToContainer(this.currentLayout.svg);
      this.applyPortraitStyling(true);
      this.setupTableListeners(svgContainer);
    },

    selectChair() {
      let chairs = this.$refs.svgContainer.querySelectorAll("#chairs");
      chairs.forEach((chair) => {
        chair.addEventListener("click", (e) => {
          this.setCurrentChair(e.target.id);
          this.$router.push("/store");
        });
      });
    },

    formatter(text) {
      if (!text) return "";
      return text.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    },

    initOpenTabs(groups) {
      if (Object.keys(this.currentLayout).length === 0) {
        return;
      }

      let tableMap = new Map();
      groups.forEach((g) => {
        if (g.id.includes("table_")) {
          tableMap.set(g.id, g);
        }
      });

      let currentLayoutName = this.currentLayout.layout;

      let relevantTabs = [];
      for (let tab of this.history) {
        let orderData = tab.doc || tab.value;
        if (!orderData || !orderData.name || orderData.payments.length > 0) continue;

        let [first, second, third] = orderData.name.split("_");
        if (`layout_${first}` === currentLayoutName) {
          relevantTabs.push({ orderData, tableId: `${second}_${third}` });
        }
      }

      this.activeTabs = relevantTabs.length;

      this.$nextTick(() => {
        relevantTabs.forEach(({ tableId }) => {
          let table = tableMap.get(tableId);
          if (table && table.children && table.children[1]) {
            table.children[1].setAttribute("fill", "red");
          }
        });
      });
    },

    zoomIn() {
      if (this.scale >= 2) return;

      const svgElement = this.$refs.svgContainer.querySelector("svg");
      if (!svgElement) return;
      this.scale += 0.1;
      svgElement.style.transform = `scale(${this.scale})`;
    },

    zoomOut() {
      if (this.scale <= 0.1) return;

      const svgElement = this.$refs.svgContainer.querySelector("svg");
      if (!svgElement) return;
      this.scale = Math.max(0.1, this.scale - 0.1);
      svgElement.style.transform = `scale(${this.scale})`;
    },
  },

  watch: {
    currentLayout: {
      handler(newLayout) {
        if (newLayout && Object.keys(newLayout).length > 0 && newLayout.svg) {
          this.$nextTick(() => {
            this.handleCurrentLayout();
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.floor-plan-container {
  width: calc(100vw - 2rem);
  height: 100%;
  padding: 1rem;
  .header {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin: 0 0 1rem 0;
    gap: 1rem;
    .info {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      padding: 1rem;
      background-color: var(--secondary-colour);
      border-radius: 1rem;
      box-shadow: var(--box-shadow);
      .blue {
        color: var(--action-colour);
      }
      h2 {
        margin: 0.5rem 1rem;
      }
    }
  }

  .actions-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: var(--secondary-colour);
    border-radius: 1rem;
    box-shadow: var(--box-shadow);

    .zoom-buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      .selected {
        background-color: var(--secondary-colour);
        box-shadow: none;
      }
      .layout-btn {
        margin: 0.5rem;
        padding: 0.5rem 1rem;
        background-color: var(--primary-colour);
        color: white;
        border: none;
        border-radius: 4px;
        box-shadow: var(--box-shadow);
        text-transform: capitalize;
        cursor: pointer;
      }
      .alt-text {
        color: var(--action-colour);
      }
    }

    .buttons-container {
      display: flex;
      flex-wrap: wrap;
      .layout-btn {
        margin: 0.5rem;
        padding: 0.5rem 1rem;
        background-color: var(--primary-colour);
        color: white;
        border: none;
        border-radius: 4px;
        box-shadow: var(--box-shadow);
        text-transform: capitalize;
        cursor: pointer;
      }
      .layout-btn:active {
        background-color: var(--action-colour);
        box-shadow: none;
      }
    }
  }
  .svg-container {
    height: 75vh;
    width: 100%;
    background-color: var(--secondary-colour);
    border-radius: 1rem;
    overflow: auto;
    box-shadow: var(--box-shadow);
    .draggable {
      cursor: pointer;
    }
  }
}

@media only screen and (orientation: portrait) {
  .header {
    flex-direction: column;
  }

  .info {
    h2 {
      text-align: center;
    }
  }
  .actions-bar {
    flex-direction: column;
  }
}
</style>
